import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconChevronLargeDown: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="chevron-large-down, chev down, down"><path fillRule="evenodd" clipRule="evenodd" d="M2.10546 9.36681C2.31716 9.01078 2.77739 8.89377 3.13342 9.10546L10.8502 13.6938C11.5589 14.1152 12.4413 14.1152 13.15 13.6938L20.8668 9.10546C21.2228 8.89377 21.6831 9.01078 21.8948 9.36681C22.1065 9.72284 21.9895 10.1831 21.6334 10.3948L13.9166 14.9831C12.7355 15.6854 11.2648 15.6854 10.0836 14.9831L2.36681 10.3948C2.01078 10.1831 1.89377 9.72284 2.10546 9.36681Z" fill="currentColor"/></CentralIconBase>;
};

export default IconChevronLargeDown;
